<template>
    <div class="cooperation-page page my-container">
        <div class="row">
            <h1 class="header">{{ t('cooperation') }}</h1>
            <div>
                <p class="description">
                    {{ cooperation['section-1'].description[locale] }}
                </p>
            </div>
        </div>
        <img alt="cooperation banner" :src="cooperation['section-1'].media_file"
            v-if="cooperation['section-1'].media_file_type === 'image'" />
        <video style="width: 100%;
             object-fit: cover; object-position: center;" v-else>
            <source :src="cooperation['section-1'].media_file" type="video/mp4" />
        </video>
        <div class="row">
            <div>
                <h2 class="header">{{ t('contactUs') }}</h2>
                <p class="disclaimer">{{ t('cooperationDisclaimer') }}</p>
            </div>
            <form class="cooperation-form" @submit.prevent="sendForm">
                <BaseInput variant="light" :placeholder="t('yourName')" v-model="form.name"
                    :class="{ error: validator.name.$error }" />
                <ClientOnly>
                    <BasePhoneInput v-model="form.phone" default-country="UZ" variant="light"
                        :error="validator.phone.$error" :search-placeholder="t('enterSearchQuery')" />
                    <template #fallback>
                        <input class="base-input light" :placeholder="t('yourPhone')" disabled />
                    </template>
                </ClientOnly>
                <BaseInput variant="light" :placeholder="t('companyName')" v-model="form.company"
                    :class="{ error: validator.company.$error }" />
                <BaseInput variant="light" :placeholder="t('yourEmail')" type="email" v-model="form.email"
                    :class="{ error: validator.email.$error }" />

                <textarea rows="4" class="base-input span2 light" :placeholder="t('yourOffer')" v-model="form.offer"
                    :class="{ error: validator.offer.$error }"></textarea>
                <button class="my-btn flex align-center justify-center" style="width: 100%;"> {{ t('send')
                    }}</button>
            </form>
        </div>
    </div>
</template>

<script setup>
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
const { locale, t } = useI18n()
const rc = useRuntimeConfig();

const { start, finish } = useLoadingIndicator();
const toast = useToast();
const cooperation = ref((await $fetch(rc.public.api + '/api/sections/cooperation')).data)
const form = reactive({
    name: '',
    phone: '',
    company: '',
    email: '',
    offer: ''
})

const rules = computed(() => ({
    name: { required },
    phone: { required },
    company: { required },
    email: { email },
    offer: { required },
}))

const validator = useVuelidate(rules, form)

async function sendForm() {
    const isValid = await validator.value.$validate()
    if (!isValid) return toast.add({
        title: t('fillForm'),
        color: 'red'
    });
    try {
        start()
        await $fetch(rc.public.api + '/api/application/cooperation', {
            body: form,
            method: 'POST'
        })
        toast.add({
            title: t('contactSuccess'),
        })
        resetForm()
    } catch (error) {
        toast.add({
            title: error?.data?.context?.message || error?.data?.message || t('errorOccured'),
            color: 'red'
        })
    } finally {
        finish()
    }
}
function resetForm() {
    form.company = '';
    form.name = '';
    form.offer = '';
    form.phone = '';
    form.email = '';
    validator.value.$reset()
}
</script>